import DataFolder from './DataFolder';
import Menu from './Menu';

export default class DataEntry {
    constructor(entry, $parent) {
        this.entry = entry;
        this.id = entry.id;
        this.permissions = entry.permissions;
        this.$el = undefined;
        this.$link = undefined;
        this.isOpen = false;
        this.$parent = $parent;
        this.instance = this;
        this.type = (this instanceof DataFolder) ? 'folder' : 'file';
        
        this.createMarkup();
        // this.addToList($parent);
    }

    createMarkup() {
        // console.log('no markup');
    }

    addToList($target) {
        $target.append(this.$html);

        this.$link = $('[data-id="' + this.id + '"]');
        this.$el = this.$link.closest('li');

        if ((this.permissions & 65536) == 65536) {
            this.showMenuButton();
        }
        this.setClickEvent();
    }
    
    showMenuButton() {
        this.$link.on('mouseover', (e) => {      
            new Menu(this.instance, this.type);

            e.stopPropagation();
        });
    }

    disableEntry() {
        if (this.$link.length) {
            this.$link.addClass('disabled');
            this.$link.find('.fa').addClass('fa-spin');
        }
    }

    enableEntry() {
        if (this.$link.length) {
            this.$link.removeClass('disabled');
            this.$link.find('.fa').removeClass('fa-spin');
        }
    }

    refreshPermissions() {
        this.$el.find('.menu-wrapper').remove();
        
        $.ajax({
            type: "post",
            dataType: "json",
            url: dataUrl,
            data: {
                "action": dataActionPrefix + "getpermission",
                "folderOrFileId": this.id
            },
            beforeSend: () => {
                securearea.addSpinner();
            },
            complete: () => {
                securearea.removeSpinner();
            },
            success: (json) => {
                if (json.success) {
                    this.permissions = json.data;
                } else {
                    return false;
                }
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/classes/DataEntry.js
 **/